<template>
  <div class="nantong">
    <van-dialog v-model:show="newShow" title="" close-on-click-overlay :show-confirm-button="false">
      <div class="nantongOverLimitTip px-[20px] py-[25px] h-[200px] text-center">
        <div class="text-[16px] text-black font-bold mt-[20px]">{{ title }}</div>
        <div class="text-[14px] text-black font-medium mt-[20px] mb-[40px]">
          {{ subTitleText }}
        </div>
        <div class="flex justify-between items-center text-[14px]">
          <div class="w-[116px] h-[30px] leading-[30px] text-white bg-black rounded-[5px]"
            @click.stop="emits('leftClick')">
              {{ leftBtnText }}
          </div>
          <div class="w-[116px] h-[30px] leading-[30px] text-white bg-[#7A51ED] rounded-[5px]"
            @click.stop="emits('rightClick')">{{ rightBtnText }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>

</template>

<script lang="ts" setup>
const authStore = useAuthStore()
const { confirmTitle } = storeToRefs(authStore)

interface Props {
  show: boolean
  title: string
  subTitle: string
  leftBtnText: string
  rightBtnText: string
}
const props = withDefaults(defineProps<Props>(), {
  show: false,
  title: '',
  subTitle: '',
  leftBtnText: '',
  rightBtnText: '',
})
const emits = defineEmits(['leftClick', 'rightClick'])
const newShow = useModel(props, 'show')
const subTitleText = computed(() => {
  console.log(confirmTitle.value,'bbb')
  return confirmTitle.value || props.subTitle
})
</script>

<style lang="scss" scoped>
.nantong {
  :deep(.van-dialog) {
    background: linear-gradient(170deg, #FFF 6.3%, #D4D4E8 97.94%) !important;
    border-radius: 14px;
    width: 300px;
  }
}
</style>
